import React from 'react';
import AuthGlass, { authGlassSx } from './AuthGlass';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

interface AuthPanelShellProps {
  children: React.ReactNode;
  onClose?: () => void;
  mode: 'login' | 'signup';
  width?: string | number;
  /**
   * Optional style overrides for the panel container.
   * Useful when reusing the shell in different contexts (e.g. Smart Search modal overlay).
   */
  containerSx?: SxProps<Theme>;
  /**
   * Optional override for the panel background color.
   * Defaults to the existing glass color used by the login page.
   */
  backgroundColor?: string;
}

const AuthPanelShell: React.FC<AuthPanelShellProps> = ({ 
  children, 
  onClose,
  mode,
  width,
  containerSx,
  backgroundColor
}) => {
  const baseSx: SxProps<Theme> = {
    position: 'relative',
    width: '100%',
    maxWidth: width || '974px',
    height: { xs: 'auto', md: mode === 'login' ? '458px' : '640px' },
    ...authGlassSx,
    borderRadius: { xs: '16px', md: '25px' },
    border: 'none',
    padding: '1.5px', // Retain the previous border's space for flow content.
    transform: 'translate3d(0,0,0)',
    overflow: 'hidden',
    fontFamily: 'Montserrat, sans-serif',
    mx: { xs: 2, md: 0 },
    boxSizing: 'border-box',
  };

  // Flatten containerSx if it's an array to ensure proper style merging
  const flattenedSx = Array.isArray(containerSx)
    ? [baseSx, ...containerSx]
    : containerSx
      ? [baseSx, containerSx]
      : baseSx;

  return (
    <Box
      sx={flattenedSx}
    >
      <AuthGlass tint={backgroundColor} />
      {children}
    </Box>
  );
};

export default AuthPanelShell;
